module.exports = __webpack_public_path__ + "8a5356e9/img/chevron-down-icon.5542f65c.svg";